// HomePage.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { SimpleBanner } from '../components/Banner';

export const HomePage = () => {
    const [activeTab, setActiveTab] = useState('biography');

    // Family Data
    const familyData = [
        { relation: "पिता", name: "पंडित प्रेम शंकर शर्मा (आचार्य जी)", icon: "fa-user-tie" },
        { relation: "माता", name: "श्रीमती पूनम शर्मा", icon: "fa-female" },
        { relation: "भाई", name: "पंडित नागेंद्र कुमार शर्मा (सामाजिक कार्यकर्ता)", icon: "fa-user-graduate" },
        { relation: "बाबा", name: "स्व. पंडित गुरुप्रसाद जी (प्रतिष्ठित सरकारी अध्यापक)", icon: "fa-chalkboard-teacher" },
        { relation: "चचेरे बाबा", name: "स्व. पंडित भगवान दीन शर्मा (अमर स्वतंत्रता सेनानी)", icon: "fa-star-of-life" }
    ];

    // Wikipedia Style Profile Data
    const wikiProfile = [
        { label: "पूरा नाम", value: "पंडित धीरेंद्र कुमार शर्मा", icon: "fa-signature" },
        { label: "परिचय", value: "प्रखर राजनेता, समाजसेवी एवं हिंदूवादी विचारक", icon: "fa-user" },
        { label: "जन्म स्थान", value: "बरवर, जिला- लखीमपुर खीरी, उत्तर प्रदेश", icon: "fa-map-marker-alt" },
        { label: "विचारधारा", value: "छत्रपति शिवाजी महाराज और छत्रपति संभाजी महाराज के आदर्श", icon: "fa-flag" },
        { label: "लोकप्रिय संबोधन", value: "हिंदू हृदय सम्राट (स्थानीय स्तर पर)", icon: "fa-crown" },
        { label: "राजनैतिक दृष्टिकोण", value: "जातिवाद और भेदभावपूर्ण राजनीति का कड़ा विरोध", icon: "fa-balance-scale" }
    ];

    // Timeline Events - WITH IMAGES (important moments)
    const timelineEvents = [
        { year: "1941-1947", title: "स्वतंत्रता संग्राम", description: "पंडित भगवान दीन शर्मा जी ने लखीमपुर खीरी जिला कारागार में कठोर कारावास काटा", hasImage: true, icon: "fa-fist-raised" },
        { year: "प्रारंभिक जीवन", title: "माताजी के संस्कार", description: "माताजी ने छत्रपति शिवाजी, संभाजी महाराज, महाराणा प्रताप की वीरता से परिचित कराया", hasImage: true, icon: "fa-heart" },
        { year: "शिक्षा", title: "दोहरी स्नातक", description: "B.Sc. (Maths) और B.Sc. (Agriculture) में स्नातक की दोहरी योग्यता", hasImage: true, icon: "fa-graduation-cap" },
        { year: "कोरोना काल", title: "जन संघर्ष", description: "महामारी में सड़क पर उतरकर हजारों परिवारों तक राशन, दवा और ऑक्सीजन पहुँचाई", hasImage: true, icon: "fa-hand-holding-heart" },
        { year: "2026", title: "राजनीतिक पदार्पण", description: "जनसत्ता दल (लोकतांत्रिक) की सदस्यता ग्रहण", hasImage: true, icon: "fa-handshake" },
        { year: "2027", title: "मिशन 2027", description: "144-मोहम्मदी विधानसभा सीट से सशक्त उम्मीदवार", hasImage: true, icon: "fa-bullseye" }
    ];

    return (
        <>
            <SimpleBanner />

            {/* Wikipedia Style Profile Section - ICONS ONLY */}
            <section id="biography" className="py-5" style={{ background: "var(--white-off)" }}>
                <Container>

                    {/* 🔶 TOP SECTION */}
                    <Row className="align-items-center mb-5">

                        {/* IMAGE */}
                        <Col md={4} className="text-center mb-4 mb-md-0">
                            <img
                                src="/images/dhirendra.jpg"
                                alt="Pandit Dhirendra Kumar Sharma"
                                className="img-fluid"
                                style={{
                                    maxHeight: "380px",
                                    borderRadius: "12px",
                                    objectFit: "cover",
                                    border: "4px solid var(--saffron-light)",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.08)"
                                }}
                            />
                        </Col>

                        {/* TEXT */}
                        <Col md={8}>
                            <h1 style={{ fontWeight: "800", color: "var(--saffron-dark)" }}>
                                पंडित धीरेंद्र कुमार शर्मा
                            </h1>

                            <h5 style={{ color: "var(--saffron-deep)", marginBottom: "15px" }}>
                             प्रखर राष्ट्रवादी नेता, समाजसेवी, हिंदूवादी विचारक
                            </h5>

                            <p style={{ color: "#444", lineHeight: "1.8" }}>
                                मैं पंडित धीरेंद्र कुमार शर्मा, अमर स्वतंत्रता सेनानी पंडित भगवान दीन शर्मा जी का वंशज हूँ।
                                राष्ट्रभक्ति और जन-सेवा मेरे जीवन का मूल आधार है। 144 विधानसभा मोहम्मदी के प्रत्येक नागरिक की सेवा
                                और सनातन धर्म की रक्षा ही मेरा संकल्प है।
                            </p>

                            {/* TAGLINE */}
                            <div
                                className="mt-3"
                                style={{
                                    background: "var(--saffron-soft)",
                                    padding: "12px 15px",
                                    borderLeft: "4px solid var(--saffron-deep)",
                                    borderRadius: "6px"
                                }}
                            >
                                <em style={{ color: "var(--saffron-dark)" }}>
                                "राष्ट्र का निर्माण जातियों के आधार पर नहीं, योग्यता के आधार पर होगा।"
                                </em>
                            </div>

                            {/* QUICK INFO */}
                            <div className="mt-4">
                                <span
                                    className="d-inline-block me-3 mb-2 px-3 py-2"
                                    style={{
                                        background: "var(--saffron-light)",
                                        borderRadius: "20px",
                                        color: "var(--saffron-dark)",
                                        fontWeight: "500"
                                    }}
                                >
                                    144 विधानसभा, मोहम्मदी
                                </span>

                                <span
                                    className="d-inline-block px-3 py-2"
                                    style={{
                                        background: "var(--white-cream)",
                                        border: "1px solid var(--saffron-light)",
                                        borderRadius: "20px",
                                        color: "var(--saffron-dark)",
                                        fontWeight: "500"
                                    }}
                                >
                                    पंडित भगवान दीन शर्मा जी की विरासत
                                </span>
                            </div>
                        </Col>
                    </Row>

                    {/* 🔷 BIO SECTION */}
                    <Row className="mb-5">

                        {/* LEFT */}
                        <Col lg={8}>
                            <h3 style={{ color: "var(--saffron-dark)", fontWeight: "700" }}>
                                विस्तृत परिचय
                            </h3>

                            <div
                                style={{
                                    width: "60px",
                                    height: "3px",
                                    background: "var(--saffron-deep)",
                                    marginBottom: "15px"
                                }}
                            ></div>

                            <p style={{ lineHeight: "1.9", color: "#444" }}>
                            पंडित धीरेंद्र कुमार शर्मा का जन्म उत्तर प्रदेश के लखीमपुर खीरी जिले के बरवर नामक गाँव में एक प्रतिष्ठित ब्राह्मण परिवार में हुआ। उनके पिता, पंडित प्रेम शंकर शर्मा (आचार्य जी), धार्मिक अनुष्ठानों और शिक्षा के क्षेत्र में गहरी रुचि रखने वाले एक सम्मानित व्यक्तित्व हैं। उनकी माता, श्रीमती पूनम शर्मा, एक सरल एवं धार्मिक महिला हैं, जिनसे उन्हें सेवा और करुणा का भाव मिला। पंडित जी के छोटे भाई, पंडित नागेंद्र कुमार शर्मा, एक सक्रिय सामाजिक कार्यकर्ता हैं और उनके राजनीतिक अभियानों में कंधे से कंधा मिलाकर चलते हैं। उनके दादा, स्व. पंडित गुरुप्रसाद जी, एक प्रतिष्ठित सरकारी अध्यापक थे, जिन्होंने सैकड़ों बच्चों के जीवन में शिक्षा की अलख जगाई। इस परिवार की तीन पीढ़ियाँ शिक्षा, धर्म और राष्ट्रसेवा के लिए समर्पित रही हैं। पंडित धीरेंद्र कुमार शर्मा का जीवन इन्हीं संस्कारों से ओत-प्रोत है। वह एक ऐसे नेता के रूप में उभरे हैं, जिनकी पहचान केवल एक राजनीतिक चेहरे के रूप में नहीं, बल्कि एक ऐसे जनसेवक के रूप में है जो 24x7 जनता की समस्याओं के समाधान के लिए तत्पर रहते हैं। उनकी सादगी, स्पष्टवादिता और निडरता ने उन्हें जन-जन का विश्वासपात्र बना दिया है।
                            </p>
                        </Col>

                        {/* RIGHT */}
                        <Col lg={4}>
                            <div
                                style={{
                                    background: "var(--white-cream)",
                                    padding: "20px",
                                    borderRadius: "10px",
                                    border: "1px solid var(--saffron-light)"
                                }}
                            >
                                <h5 style={{ color: "var(--saffron-dark)" }}>प्रेरणा</h5>
                                <p style={{ color: "#444" }}>
                                    छत्रपति शिवाजी महाराज, धर्मवीर संभाजी महाराज एवं पूज्य दादाजी
                                </p>
                            </div>
                        </Col>
                    </Row>

                    {/* 🔶 JANATA DARBAR */}
                    <Row>
                        <Col>
                            <div
                                style={{
                                    background: "var(--saffron-soft)",
                                    padding: "25px",
                                    borderRadius: "12px",
                                    textAlign: "center",
                                    border: "1px solid var(--saffron-light)"
                                }}
                            >
                                <h4 style={{ color: "var(--saffron-dark)", marginBottom: "10px" }}>
                                    जनता दरबार
                                </h4>

                                <p style={{ marginBottom: "5px", color: "#333" }}>
                                    <strong>समय:</strong> प्रतिदिन शाम 7:00 बजे से रात 10:00 बजे तक
                                </p>

                                <p style={{ marginBottom: "5px", color: "#333" }}>
                                    <strong>स्थान:</strong> बरवर नगर पंचायत
                                </p>

                                <p style={{ fontStyle: "italic", color: "var(--saffron-dark)" }}>
                                    "समस्या आपकी, संघर्ष मेरा"
                                </p>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>

            {/* गौरवशाली वंश एवं ऐतिहासिक विरासत - WITH IMAGE (freedom fighter photo) */}
            <section className="py-5" style={{ backgroundColor: 'var(--white-off)' }}>
                <Container>
                    <h2 className="section-title" style={{ fontSize: '2.0rem', fontWeight: 700, color: '#1e1e1e' }}>
                        <i className="fas fa-landmark me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        गौरवशाली वंश एवं ऐतिहासिक विरासत
                    </h2>
                    <div className="title-underline mb-4" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                    <Row className="g-4">
                        <Col lg={8}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <Row className="g-4">
                                        <Col md={4}>
                                            {/* IMPORTANT: Freedom Fighter Image - Place actual photo here */}
                                            <div className="rounded-3 d-flex align-items-center justify-content-center"
                                                style={{ width: '100%', height: '250px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                                <i className="fas fa-user-shield fa-5x" style={{ color: 'var(--saffron-deep)' }}></i>
                                                {/* Replace above icon with: <img src="/images/bhagwan-deen-sharma.jpg" alt="स्वर्गीय पंडित भगवान दीन शर्मा जी" className="img-fluid rounded-3" /> */}
                                            </div>
                                        </Col>
                                        <Col md={8}>
                                            <div className="d-flex align-items-center gap-3 mb-3">
                                                <i className="fas fa-star-of-life fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                                <div>
                                                    <h3 style={{ color: 'var(--saffron-dark)' }}>स्वर्गीय पंडित भगवान दीन शर्मा जी</h3>
                                                    <p style={{ color: '#4f4f4f', fontStyle: 'italic' }}>
                                                        <i className="fas fa-quote-left me-1" style={{ color: 'var(--saffron-deep)' }}></i>
                                                        प्रखर स्वतंत्रता सेनानी
                                                    </p>
                                                </div>
                                            </div>

                                            <p style={{ fontSize: '1rem', lineHeight: 1.8 }}>
                                                पंडित धीरेंद्र कुमार शर्मा एक ऐसे परिवार से आते हैं जिसकी जड़ें भारत के स्वाधीनता संग्राम और
                                                राष्ट्रभक्ति में समाहित हैं। उनके दादा, स्वर्गीय पंडित भगवान दीन शर्मा जी, एक प्रखर स्वतंत्रता सेनानी थे।
                                            </p>
                                        </Col>
                                    </Row>

                                    <div className="mt-4 p-3 rounded-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                                        <p className="mb-2 fw-bold" style={{ color: 'var(--saffron-dark)' }}>
                                            <i className="fas fa-scroll me-2"></i>📜 आधिकारिक प्रमाण:
                                        </p>
                                        <p className="mb-0">उनके इस महान त्याग के आधिकारिक रिकॉर्ड आज भी जिला कोषागार, निरीक्षक कार्यालय और जिला कारागार के अभिलेखों में सुरक्षित हैं।</p>
                                    </div>

                                    <div className="d-flex flex-wrap gap-2 mt-4">
                                        <span className="badge p-2" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white' }}>
                                            <i className="fas fa-calendar-alt me-1"></i> 1941-1947 कारावास
                                        </span>
                                        <span className="badge p-2" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white' }}>
                                            <i className="fas fa-gavel me-1"></i> जिला कारागार, लखीमपुर खीरी
                                        </span>
                                        <span className="badge p-2" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white' }}>
                                            <i className="fas fa-medal me-1"></i> वार्षिक सम्मान
                                        </span>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={4}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="text-center mb-4">
                                        <i className="fas fa-file-contract fa-4x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
                                        <h4 style={{ color: 'var(--saffron-dark)' }}>राजकीय प्रमाण</h4>
                                    </div>

                                    <div className="mb-4">
                                        {['जिला कोषागार', 'निरीक्षक कार्यालय', 'जिला कारागार'].map((item, index) => (
                                            <div key={index} className="d-flex justify-content-between py-2" style={{ borderBottom: '1px solid var(--saffron-light)' }}>
                                                <span><i className="fas fa-building me-2" style={{ color: 'var(--saffron-deep)' }}></i>{item}</span>
                                                <span style={{ color: 'var(--saffron-deep)' }}><i className="fas fa-check-circle me-1"></i>दर्ज</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="text-center">
                                        <i className="fas fa-trophy fa-3x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                        <p className="fw-bold mb-1">वार्षिक सम्मान</p>
                                        <p style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-calendar-check me-1"></i>
                                            15 अगस्त एवं 26 जनवरी को नगर पंचायत बरवर द्वारा ससम्मान अभिनंदन
                                        </p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* माताजी के संस्कार एवं वैचारिक नींव - WITH IMAGE (mother's photo) */}
            <section className="py-5">
                <Container>
                    <Row className="align-items-center g-4">
                        <Col lg={5}>
                            <div className="position-relative">
                                {/* IMPORTANT: Mother's Image - Place actual photo here */}
                                <div className="rounded-4 d-flex align-items-center justify-content-center"
                                    style={{ width: '100%', height: '400px', backgroundColor: 'var(--saffron-soft)', border: '4px solid var(--saffron-deep)' }}>
                                    <i className="fas fa-female fa-6x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    {/* Replace above icon with: <img src="/images/mother.jpg" alt="श्रीमती पूनम शर्मा" className="img-fluid rounded-4" /> */}
                                </div>
                                <div className="position-absolute bottom-0 start-50 translate-middle-x bg-white p-3 rounded-3 shadow-sm"
                                    style={{ width: '90%', transform: 'translateX(-50%) translateY(50%)', border: '2px solid var(--saffron-deep)' }}>
                                    <h4 className="text-center mb-0" style={{ color: 'var(--saffron-dark)' }}>
                                        <i className="fas fa-heart me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                        श्रीमती पूनम शर्मा
                                    </h4>
                                    <p className="text-center mb-0" style={{ fontStyle: 'italic' }}>"संस्कारों की जननी"</p>
                                </div>
                            </div>
                        </Col>

                        <Col lg={7}>
                            <h2 className="section-title" style={{ fontSize: '2.0rem', fontWeight: 700, color: '#1e1e1e' }}>
                                <i className="fas fa-female me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                माताजी के संस्कार एवं वैचारिक नींव
                            </h2>
                            <div className="title-underline mb-4" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                            <p style={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                                धीरेंद्र जी के व्यक्तित्व निर्माण में उनकी माताजी की केंद्रीय भूमिका रही है। बचपन में ही उनकी माताजी ने
                                उन्हें न केवल पारंपरिक शिक्षा दी, बल्कि महापुरुषों के जीवन चरित्र से भी परिचित कराया।
                            </p>

                            <Row className="g-3 mt-3">
                                <Col sm={6}>
                                    <div className="p-3 rounded-3 h-100" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                                        <div className="d-flex align-items-center gap-3 mb-2">
                                            <i className="fas fa-shield-alt fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                                            <h5 className="mb-0" style={{ color: 'var(--saffron-dark)' }}>भारतीय वीर</h5>
                                        </div>
                                        <p className="mb-0">छत्रपति शिवाजी महाराज, संभाजी महाराज, महाराणा प्रताप, राणा सांगा</p>
                                    </div>
                                </Col>
                                <Col sm={6}>
                                    <div className="p-3 rounded-3 h-100" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                                        <div className="d-flex align-items-center gap-3 mb-2">
                                            <i className="fas fa-globe-asia fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                                            <h5 className="mb-0" style={{ color: 'var(--saffron-dark)' }}>वैश्विक दूरदर्शी</h5>
                                        </div>
                                        <p className="mb-0">नेल्सन मंडेला, अब्राहम लिंकन, जॉर्ज वॉशिंगटन, अंबानी, बिल गेट्स</p>
                                    </div>
                                </Col>
                            </Row>

                            <div className="mt-4 p-3 rounded-3 position-relative" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                                <i className="fas fa-quote-left fa-2x" style={{ color: 'var(--saffron-deep)', position: 'absolute', top: '10px', left: '10px', opacity: '0.3' }}></i>
                                <p className="px-4 pt-3" style={{ fontStyle: 'italic' }}>
                                    माताजी के आदेश पर उन्होंने बचपन में ही निर्धन बच्चों को निःशुल्क शिक्षा देकर समाज के प्रति अपने कर्तव्यों का निर्वहन शुरू कर दिया था।
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* शैक्षणिक योग्यता - ICONS ONLY (education icons) */}
            <section className="py-5" style={{ backgroundColor: 'var(--white-off)' }}>
                <Container>
                    <h2 className="section-title text-center" style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1e1e1e' }}>
                        <i className="fas fa-graduation-cap me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        शैक्षणिक योग्यता
                    </h2>
                    <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                    <Row className="g-4">
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '100px', height: '100px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-book-open fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>प्रारंभिक शिक्षा</h4>
                                    <p className="mb-0">माताजी के प्रत्यक्ष मार्गदर्शन में घर पर ही संस्कारों और शिक्षा का समावेश</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '100px', height: '100px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-school fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>स्कूली शिक्षा</h4>
                                    <p className="mb-0">हाईस्कूल और इंटरमीडिएट की परीक्षा गृह नगर बरवर से उत्तीर्ण</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '100px', height: '100px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-university fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>उच्च शिक्षा</h4>
                                    <p>B.Sc. (Maths) और B.Sc. (Agriculture) में दोहरी स्नातक</p>
                                    <p className="mb-0 small">कृषि विज्ञान की समझ किसानों की समस्याओं को वैज्ञानिक दृष्टिकोण से सुलझाने में सहायक</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Timeline - जीवन यात्रा - WITH IMAGES (important life events) */}
            <section className="py-5">
                <Container>
                    <h2 className="section-title" style={{ fontSize: '2.0rem', fontWeight: 700, color: '#1e1e1e' }}>
                        <i className="fas fa-timeline me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        जीवन यात्रा
                    </h2>
                    <div className="title-underline mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                    <Row className="g-4">
                        {timelineEvents.map((event, index) => (
                            <Col lg={4} md={6} key={index}>
                                <Card className="border-0 shadow-sm h-100">
                                    <div style={{ height: '200px', backgroundColor: 'var(--saffron-soft)', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {/* IMPORTANT: Timeline Images - Place actual event photos here */}
                                        <i className={`fas ${event.icon} fa-4x`} style={{ color: 'var(--saffron-deep)' }}></i>
                                        {/* Replace above icon with: <img src={`/images/timeline-${index}.jpg`} alt={event.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> */}
                                    </div>
                                    <Card.Body>
                                        <span className="badge mb-2" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white' }}>
                                            <i className="fas fa-calendar-alt me-1"></i> {event.year}
                                        </span>
                                        <h4 style={{ color: 'var(--saffron-dark)' }}>{event.title}</h4>
                                        <p className="mb-0" style={{ color: '#4f4f4f' }}>{event.description}</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* कोरोना काल का जन संघर्ष - WITH IMAGE (corona service photo) */}
            <section className="py-5" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                <Container>
                    <Row className="align-items-center g-4">
                        <Col lg={6}>
                            <h2 className="section-title" style={{ fontSize: '2.0rem', fontWeight: 700, color: '#1e1e1e' }}>
                                <i className="fas fa-heartbeat me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                कोरोना काल का जन संघर्ष
                            </h2>
                            <div className="title-underline mb-4" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                            <p style={{ fontSize: '1.2rem', lineHeight: 1.9 }}>
                                कोरोना महामारी के भीषण संकट में पंडित धीरेंद्र कुमार शर्मा ने सड़क पर उतरकर अत्यधिक जन संघर्ष किया।
                                अपनी जान की परवाह किए बिना हर जरूरतमंद तक राशन, दवा और ऑक्सीजन पहुँचाकर
                                <strong className="mx-1" style={{ color: 'var(--saffron-deep)' }}>'नर सेवा ही नारायण सेवा'</strong>
                                के मंत्र को सिद्ध किया।
                            </p>

                            <Row className="mt-4 text-center">
                                <Col sm={4}>
                                    <div className="p-3" style={{ backgroundColor: 'var(--white-pure)', borderRadius: '10px' }}>
                                        <i className="fas fa-utensils fa-2x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                        <div style={{ fontSize: '2rem', color: 'var(--saffron-deep)' }}>5000+</div>
                                        <div>परिवारों को राशन</div>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className="p-3" style={{ backgroundColor: 'var(--white-pure)', borderRadius: '10px' }}>
                                        <i className="fas fa-lungs fa-2x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                        <div style={{ fontSize: '2rem', color: 'var(--saffron-deep)' }}>200+</div>
                                        <div>मरीजों को ऑक्सीजन</div>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className="p-3" style={{ backgroundColor: 'var(--white-pure)', borderRadius: '10px' }}>
                                        <i className="fas fa-hands-helping fa-2x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                        <div style={{ fontSize: '2rem', color: 'var(--saffron-deep)' }}>100+</div>
                                        <div>अंतिम संस्कार में सहयोग</div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        <Col lg={6}>
                            {/* IMPORTANT: Corona Service Image - Place actual photo here */}
                            <div className="rounded-4 d-flex align-items-center justify-content-center"
                                style={{ width: '100%', height: '400px', backgroundColor: 'var(--white-pure)', border: '4px solid var(--saffron-deep)' }}>
                                <i className="fas fa-hand-holding-heart fa-6x" style={{ color: 'var(--saffron-deep)' }}></i>
                                {/* Replace above icon with: <img src="/images/corona-service.jpg" alt="कोरोना काल सेवा" className="img-fluid rounded-4" /> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* सामाजिक संघर्ष एवं जनसेवा का सात वर्षीय सफर - ICONS ONLY */}
            <section className="py-5">
                <Container>
                    <h2 className="section-title" style={{ fontSize: '2.0rem', fontWeight: 700, color: '#1e1e1e' }}>
                        <i className="fas fa-handshake me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        सामाजिक संघर्ष एवं जनसेवा का सात वर्षीय सफर
                    </h2>
                    <div className="title-underline mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                    <Row className="g-4">
                        <Col lg={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '120px', height: '120px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-star fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>कोरोना काल का उदय</h4>
                                    <p className="mb-0">जब समाज में भय व्याप्त था, तब अपनी माताजी की प्रेरणा से उन्होंने धरातल पर उतरकर बेसहारा लोगों की सेवा की।</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '120px', height: '120px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-clock fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>7 वर्षों का संघर्ष</h4>
                                    <p className="mb-0">पिछले 7 वर्षों के निरंतर संघर्ष के दौरान क्षेत्र के उत्थान, युवाओं की शिक्षा और गरीबों के हक की लड़ाई को जीवन लक्ष्य बनाया।</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '120px', height: '120px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-bolt fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>24/7 सक्रियता</h4>
                                    <p className="mb-0">क्षेत्र की जनता और नगरवासियों की समस्याओं के समाधान हेतु चौबीसों घंटे सक्रिय।</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* जनता दरबार - ICONS ONLY */}
            <section id="darbar" className="py-5" style={{ backgroundColor: 'var(--white-off)' }}>
                <Container>
                    <div className="p-4 p-md-5 text-center" style={{ backgroundColor: 'var(--saffron-soft)', border: '3px dashed var(--saffron-deep)', borderRadius: '30px' }}>
                        <i className="fas fa-users fa-4x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
                        <h2 className="display-4 mb-3" style={{ color: 'var(--saffron-dark)' }}>जनता दरबार</h2>
                        <p className="fs-3 fst-italic mb-4">
                            <i className="fas fa-quote-left me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                            "समस्या आपकी, संघर्ष मेरा"
                        </p>

                        <Row className="g-4">
                            <Col md={4}>
                                <div className="p-3">
                                    <i className="fas fa-clock fa-3x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                    <h4 className="mt-2">समय</h4>
                                    <p className="mb-0">प्रतिदिन शाम 7:00 बजे से रात 10:00 बजे तक</p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="p-3">
                                    <i className="fas fa-map-marker-alt fa-3x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                    <h4 className="mt-2">स्थान</h4>
                                    <p className="mb-0">बरवर नगर पंचायत, जनपद - खीरी (उत्तर प्रदेश)</p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="p-3">
                                    <i className="fas fa-bullseye fa-3x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                    <h4 className="mt-2">उद्देश्य</h4>
                                    <p className="mb-0">क्षेत्र के हर नागरिक की सीधी सुनवाई</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>

            {/* घोषणापत्र - ICONS ONLY */}
            <section id="manifesto" className="py-5">
                <Container>
                    <h2 className="section-title text-center" style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1e1e1e' }}>
                        <i className="fas fa-file-signature me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        घोषणापत्र (हमारा संकल्प)
                    </h2>
                    <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                    <Row className="g-4">
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '100px', height: '100px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-flag-india fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>स्वतंत्रता सेनानियों के सपनों का भारत</h4>
                                    <p className="mb-0">विकसित मोहम्मदी का निर्माण हमारा लक्ष्य</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '100px', height: '100px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-users fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>युवा सशक्तिकरण</h4>
                                    <p className="mb-0">युवाओं में राष्ट्रभक्ति, संस्कार और स्वरोजगार को बढ़ावा</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '100px', height: '100px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-seedling fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 style={{ color: 'var(--saffron-dark)' }}>शिक्षा, स्वास्थ्य और कृषि</h4>
                                    <p className="mb-0">तीनों क्षेत्रों में ऐतिहासिक और आधुनिक सुधार</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* राजनीतिक विजन एवं मिशन 2027 - WITH IMAGE (campaign photo) */}
            <section className="py-5" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                <Container>
                    <Row className="align-items-center g-4">
                        <Col lg={6}>
                            <h2 className="section-title" style={{ fontSize: '2.0rem', fontWeight: 700, color: '#1e1e1e' }}>
                                <i className="fas fa-vote-yea me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                राजनीतिक विजन एवं मिशन 2027
                            </h2>
                            <div className="title-underline mb-4" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                            <p style={{ fontSize: '1.2rem', lineHeight: 1.8 }}>
                                जनता के प्रबल समर्थन और क्षेत्र के विकास की सामूहिक मांग को देखते हुए,
                                धीरेंद्र जी ने वर्ष 2026 में जनसत्ता दल (लोकतांत्रिक) की सदस्यता ग्रहण की।
                            </p>

                            <div className="p-4 rounded-4 mt-4" style={{ backgroundColor: 'var(--white-pure)' }}>
                                <h4 className="mb-3" style={{ color: 'var(--saffron-dark)' }}>
                                    <i className="fas fa-bullseye me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                                    मिशन 2027
                                </h4>
                                <p className="fs-5">
                                    आगामी 2027 के विधानसभा चुनाव में 144-मोहम्मदी विधानसभा सीट से
                                    <strong className="mx-1" style={{ color: 'var(--saffron-deep)' }}>सशक्त और सेवाभावी उम्मीदवार</strong> के रूप में प्रस्तुत।
                                </p>
                                <p className="fst-italic mt-3 mb-0">
                                    विजन: मोहम्मदी को एक आदर्श विधानसभा क्षेत्र बनाना, जहाँ विकास और न्याय सबका अधिकार हो।
                                </p>
                            </div>
                        </Col>

                        <Col lg={6}>
                            {/* IMPORTANT: Campaign/Mission Image - Place actual photo here */}
                            <div className="rounded-4 d-flex align-items-center justify-content-center"
                                style={{ width: '100%', height: '400px', backgroundColor: 'var(--white-pure)', border: '4px solid var(--saffron-deep)' }}>
                                <i className="fas fa-flag-checkered fa-6x" style={{ color: 'var(--saffron-deep)' }}></i>
                                {/* Replace above icon with: <img src="/images/mission-2027.jpg" alt="मिशन 2027" className="img-fluid rounded-4" /> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* प्रेरणा स्रोत - WITH IMAGES (inspirational figures) */}
            <section className="py-5">
                <Container>
                    <h2 className="section-title text-center" style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1e1e1e' }}>
                        <i className="fas fa-star me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        प्रेरणा स्रोत
                    </h2>
                    <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                    <Row className="g-4">
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <div style={{ height: '250px', backgroundColor: 'var(--saffron-soft)', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {/* IMPORTANT: Shivaji Maharaj Image */}
                                    <i className="fas fa-horse-head fa-4x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    {/* Replace with: <img src="/images/shivaji-maharaj.jpg" alt="छत्रपति शिवाजी महाराज" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> */}
                                </div>
                                <Card.Body>
                                    <h3 style={{ color: 'var(--saffron-dark)' }}>छत्रपति शिवाजी महाराज</h3>
                                    <p>हिन्दवी स्वराज्य के संस्थापक, धर्म और संस्कृति के रक्षक</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <div style={{ height: '250px', backgroundColor: 'var(--saffron-soft)', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {/* IMPORTANT: Sambhaji Maharaj Image */}
                                    <i className="fas fa-shield-alt fa-4x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    {/* Replace with: <img src="/images/sambhaji-maharaj.jpg" alt="धर्मवीर संभाजी महाराज" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> */}
                                </div>
                                <Card.Body>
                                    <h3 style={{ color: 'var(--saffron-dark)' }}>धर्मवीर संभाजी महाराज</h3>
                                    <p>धर्म और स्वाभिमान के लिए बलिदान देने वाले वीर योद्धा</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100 text-center">
                                <div style={{ height: '250px', backgroundColor: 'var(--saffron-soft)', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {/* IMPORTANT: Bhagwan Deen Sharma Image */}
                                    <i className="fas fa-user-tie fa-4x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    {/* Replace with: <img src="/images/bhagwan-deen-sharma-large.jpg" alt="पूज्य दादाजी" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> */}
                                </div>
                                <Card.Body>
                                    <h3 style={{ color: 'var(--saffron-dark)' }}>पूज्य दादाजी</h3>
                                    <p>स्व. पंडित भगवान दीन शर्मा जी, अमर स्वतंत्रता सेनानी</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* संपर्क विवरण - MIX OF ICONS AND IMAGES */}
            <section id="contact" className="py-5 text-center" style={{ backgroundColor: 'var(--white-off)' }}>
                <Container>
                    <h2 className="section-title" style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1e1e1e' }}>
                        <i className="fas fa-address-book me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        संपर्क करें
                    </h2>
                    <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

                    <Row className="justify-content-center g-4">
                        <Col md={3}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '80px', height: '80px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-map-marker-alt fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 className="mb-2">पता</h4>
                                    <p className="mb-0">बरवर नगर पंचायत, जनपद - खीरी (उत्तर प्रदेश)</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '80px', height: '80px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-phone-alt fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 className="mb-2">मोबाइल</h4>
                                    <p className="fs-4 fw-bold mb-0">7565838125</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{ width: '80px', height: '80px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                                        <i className="fas fa-envelope fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                                    </div>
                                    <h4 className="mb-2">ईमेल</h4>
                                    <p className="mb-0">awashthisonamsharma@gmail.com</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <div className="mt-5">
                        <Button
                            href="tel:7565838125"
                            className="px-5 py-3 rounded-pill fw-bold border-0"
                            style={{ backgroundColor: 'var(--saffron-deep)', color: 'var(--white-pure)', fontSize: '1.2rem' }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = 'var(--saffron-deep)';
                                e.target.style.border = '2px solid var(--saffron-deep)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'var(--saffron-deep)';
                                e.target.style.color = 'var(--white-pure)';
                                e.target.style.border = 'none';
                            }}
                        >
                            <i className="fas fa-phone-alt me-2"></i>
                            तुरंत संपर्क करें
                        </Button>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default HomePage;